<template>
  <button class="button-scroll" :aria-label="ariaLabel" @click="scrollDown">
    <span>{{ $t("general.ctas.scrollDown") }}</span>
  </button>
</template>

<script setup>
defineProps({
  ariaLabel: String,
  cta: String,
});

function scrollDown() {
  window.scrollTo({
    top: window.innerHeight,
    behavior: "smooth",
  });
}
</script>

<style lang="scss" scoped>
.button-scroll {
  padding: 0.25rem;
  height: 100px;
  width: fit-content;
  color: white;
  --size-bar: 1;
  border-left: solid calc(var(--size-bar) * 1px) var(--white-disabled);
  padding-left: toRem(16);
  color: var(--white-disabled);
  @include overlay-m;
  position: relative;
  span {
    opacity: .8;
  }


  &::before {
    content: "";
    position: absolute;
    --size: 5;
    width: toRem(var(--size));
    height: toRem(var(--size));
    background-color: var(--white-disabled);
    top: toRem(calc(var(--size) / 2 * -1));
    left: toRem(calc(((var(--size) / 2) + (var(--size-bar) / 2)) * -1));
    transform: rotate(45deg);
  }

  &:hover {
    // color: var(--brand-stronger);
    span {
      opacity: 1;
    }

    ::v-deep(.svg-fill) {
      // fill:  var(--brand-stronger);
    }
  }

  .tablet &,
  .mobile & {
    align-self: end;
    display: flex;
  }
}
</style>
